import { takeLatest } from 'redux-saga/effects';
import {  CLEAR_PRICING } from '../../actions/actionTypes';
import safeSaga from '../safeSaga';
import { harmonyProductData } from '../common/pricing/harmonyProductData';
import { configuratorPricingLifeCycleEventBusTrigger } from '../common/pricing/configuratorPricingLifeCycleEventBus';

function* clearPricing(action){
  const { originalPrice, specialPrice } = action;

  const discount = 0;
  const percent = NaN;
  const specialBuy = null;
  const someSkusHaveZeroPrice = true;

  const propProductData = harmonyProductData(originalPrice, discount, percent, specialBuy, specialPrice, someSkusHaveZeroPrice);

  configuratorPricingLifeCycleEventBusTrigger(propProductData);
}

export default function* clearPricingSaga() {
  yield takeLatest(CLEAR_PRICING, safeSaga(clearPricing));
}
